<template>
  <PageTemplate title="Canais de Atendimento" no-container simple>
    <v-container class="py-15">
      <div class="text-center">
        <div>Encontre o setor que você deseja entrar em contato</div>
      </div>

      <div class="container-atendimento mt-10">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-text>
                <div class="button-contact d-flex align-center">
                  <div class="icon">
                    <v-icon size="24" class="mr-2">far fa-comment-alt</v-icon>
                  </div>
                  <div>
                    <h4 class="py-0 my-0">Fale com um atendente</h4>
                    <a
                      class="text-decoration-none"
                      href="#"
                      @click.prevent="openChat"
                      id="chat-online"
                    >
                      Clique aqui
                    </a>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="12"
            v-for="(contact, keyContact) in contacts"
            :key="keyContact"
          >
            <v-card elevation="2">
              <v-card-text>
                <div class="button-contact d-flex align-center">
                  <div class="icon">
                    <v-icon v-if="contact.icon" :size="'24'" class="mr-2">
                      {{ contact.icon }}
                    </v-icon>
                    <v-img
                      class="mr-1"
                      v-else-if="contact.img"
                      :src="contact.img"
                    ></v-img>
                  </div>
                  <div>
                    <h4 class="py-0 my-0">{{ contact.title }}</h4>
                    <a
                      class="text-decoration-none"
                      target="_blank"
                      :href="contact.link"
                      :id="contact.idcss"
                    >
                      <div v-html="contact.text"></div>
                    </a>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container id="contact" class="mb-15">
      <v-row class="align-center">
        <v-col v-if="!smAndDown" cols="12" lg="6" class="d-flex justify-center">
          <figure>
            <v-img
              class="contact-img"
              :src="this.files + item.img_contact"
            ></v-img>
          </figure>
        </v-col>
        <v-col cols="12" lg="5">
          <v-sheet color="grey" class="py-10 px-10 rounded">
            <TitleWidget :align="'left'">Fale conosco</TitleWidget>
            <div>Envie uma mensagem no formulário abaixo</div>
            <ContactForm
              class="mt-5"
              :action="server + formAction"
              response-to="/contato/obrigado"
            />
          </v-sheet>
        </v-col>
      </v-row>
      <div v-html="item.map"></div>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import ContactForm from "../components/forms/ContactForm.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import { getIcon } from "../utils/contactIcons";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  computed: {
    item() {
      return this.$rest("informations").item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    contacts() {
      return this.$rest("contacts").list.map((item) => {
        return {
          title: item.title,
          text: item.text,
          link: item.link,
          idcss: item.idcss,
          icon: this.getIcon(item.icon.title),
          img: this.files + item.img + "?resize=1&w=24",
        };
      });
    },
  },
  methods: {
    getIcon,
    openChat() {
      if (window.$chatwoot) {
        window.$chatwoot.toggle("open");
      } else {
        alert(
          "O chat ainda está carregando. Tente novamente em alguns segundos."
        );
      }
    },
  },
  created() {
    this.$rest("contacts").get();
  },
  components: {
    PageTemplate,
    ContactForm,
    TitleWidget,
  },
};
</script>

<style>
.container-atendimento {
  width: 500px;
  max-width: 100%;
  margin: auto;
}
</style>
